import { gql } from "@apollo/client";

export const CARD_DELETE = gql`
  mutation disableCard($cardId: String!) {
    disableCard(
      cardId: $cardId,
    ) {
      card {
        id,
        cardBrand,
        last4,
        cardholderName,
        customerId,
        cardType,
        expMonth,
        expYear,
      },
      success,
      messages,
    }
  }`;
